import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
import { GraduationCapIcon, StethoscopeIcon, UsersIcon, TargetIcon } from 'lucide-react';
const audiences = [{
  icon: GraduationCapIcon,
  title: 'Fonoaudiólogas recién egresadas',
  desc: 'Que tienen la teoría pero no los protocolos clínicos para el día a día real del consultorio.'
}, {
  icon: StethoscopeIcon,
  title: 'Trabajás en consulta privada con niños',
  desc: 'Con un consultorio propio o alquilado por horas, en zona residencial o clínica.'
}, {
  icon: UsersIcon,
  badge: 'NUEVO',
  title: 'Fonoaudiólogas que quieren supervisar equipos',
  desc: 'Querés estandarizar los protocolos de tu equipo y que todas trabajen con el mismo sistema.'
}, {
  icon: TargetIcon,
  title: 'Buscás evaluación con criterio propio',
  desc: 'Vas por dominar la selección de instrumentos, la redacción de informes y la devolución diagnóstica con seguridad real.'
}];
export function TargetAudience() {
  return <section className="py-12 md:py-20 px-4 md:px-8 bg-teal-900 text-white" data-id="element-274">
      <div className="max-w-3xl mx-auto" data-id="element-275">
        <SectionHeader title={<span className="text-white" data-id="element-277">¿PARA QUIÉN ES?</span>} subtitle={<span className="text-teal-100" data-id="element-278">
              Diseñado para vos si querés ejercer con seguridad y construir un
              consultorio sólido
            </span>} className="mb-8 md:mb-12" data-id="element-276" />

        <div className="bg-teal-800/40 rounded-2xl md:rounded-3xl border border-teal-700 overflow-hidden divide-y divide-teal-700/60 backdrop-blur-sm" data-id="element-279">
          {audiences.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-30px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.08
          }} className="group flex items-start gap-4 md:gap-5 p-4 md:p-5 hover:bg-teal-800/60 transition-colors relative" data-id="element-280">
                <div className="shrink-0 w-10 h-10 md:w-11 md:h-11 bg-teal-700 group-hover:bg-teal-600 rounded-xl flex items-center justify-center transition-colors" data-id="element-281">
                  <Icon className="text-teal-100" size={20} data-id="element-282" />
                </div>
                <div className="flex-grow min-w-0 pt-0.5" data-id="element-283">
                  <div className="flex items-center gap-2 mb-0.5 md:mb-1 flex-wrap" data-id="element-284">
                    <h3 className="font-bold text-white leading-tight text-sm md:text-base font-serif" data-id="element-285">
                      {item.title}
                    </h3>
                    {item.badge && <span className="bg-terracotta text-white text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider" data-id="element-286">
                        {item.badge}
                      </span>}
                  </div>
                  <p className="text-xs md:text-sm text-teal-100/80 leading-relaxed" data-id="element-287">
                    {item.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="text-center mt-8 md:mt-10" data-id="element-288">
          <button onClick={() => document.getElementById('guarantee')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-teal-200 hover:text-white font-medium transition-colors inline-flex items-center gap-2 text-sm md:text-base" data-id="element-289">
            ¿No estás segura si es para vos? Tenés 7 días de garantía →
          </button>
        </div>
      </div>
    </section>;
}